"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValorPorNome = exports.remove = exports.update = exports.create = exports.findOne = exports.findAll = void 0;
const core_1 = require("./core");
const search_1 = require("./search");
function findAll(page = 1, search) {
    const encodedSearch = search_1.encodeSearchValues(search);
    return core_1.get('Parametro', 'lista', Object.assign({ pg: page }, encodedSearch))
        .then(({ dados, paginacao }) => {
        if (dados.length === 0)
            return {
                elements: [],
                elementsPerPage: 0,
                totalElements: 0,
                currentPage: 0,
                totalPages: 0
            };
        return {
            elements: dados,
            elementsPerPage: paginacao.totalRegPorPagina,
            totalElements: paginacao.totalRegEncontrados,
            currentPage: paginacao.pagAtual,
            totalPages: paginacao.qtdPag
        };
    });
}
exports.findAll = findAll;
function findOne(id) {
    return core_1.get('Parametro', 'detalhe', { id });
}
exports.findOne = findOne;
function create(data) {
    return core_1.post('Parametro', 'cadastro', data);
}
exports.create = create;
function update(id, data) {
    return core_1.put('Parametro', 'update', Object.assign({ id }, data));
}
exports.update = update;
function remove(id) {
    return core_1.del('Parametro', 'exclui', { id });
}
exports.remove = remove;
function getValorPorNome(nome) {
    return core_1.get('Parametro', 'getValorPorNome', { nome })
        .then(({ valParametro }) => valParametro);
}
exports.getValorPorNome = getValorPorNome;
